import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_PROF_DASHBOARD } from '../../graphql/query/dashboardProf/dashboardQuery';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GraphQLError } from 'graphql';
import { useRefetchData } from '../../helpers/refetch/refetchData';
import EspaceProfView from './EspaceProf.view';
import { GetProfDashboardQuery } from '../../graphql/generated/graphql';
import { useHistory } from 'react-router-dom';
import { getGoToPage } from '../../helpers/page/goToPage';
import { saveLastSeenTab } from 'store/actions/ui.actions';
import { selectMyClassTab } from 'store/selectors/ui.selectors';
import {
  getClasseDefWithUserAndNumbersOfOrderToRemindFromQuery,
  getElevesDashboardProfFromQuery
} from '../../helpers/transformApiResponse/classe';
import { maClassecsv } from 'helpers/csv/maClassecsv';
import { useDispatch, useSelector } from 'react-redux';
import { myClassTabType } from 'types/ui';
const MaClasse = () => {
  const defaultTab = useSelector(selectMyClassTab);
  const dispatch = useDispatch();
  const [tab, setTab] = useState<number>(defaultTab);
  const [csvData, setCsvData] = useState(null);
  const history = useHistory();

  const { data, loading, error, refetch } = useQuery<GetProfDashboardQuery>(
    GET_PROF_DASHBOARD
  );
  useRefetchData(refetch);

  let users = null;
  let classe = null;

  useEffect(() => {
    if (users && classe) {
      const newCsvData = maClassecsv(users, classe, tab);
      setCsvData(newCsvData);
    }
    // eslint-disable-next-line
  }, [tab, data]);

  const handleSetTab = (newTab: myClassTabType) => {
    setTab(newTab);
    dispatch(saveLastSeenTab(newTab));
  };

  if (loading) return <LoadingContainer />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new GraphQLError(
            'Erreur dans la récupération des données (classe ou Quiz)'
          )
        }
      />
    );

  users = data
    ? data?.getProfDashboard?.classe?.users?.map(u =>
        getElevesDashboardProfFromQuery(
          u,
          data?.getUnpayedCoByEleve.find(eleve => eleve.id.toString() === u.id)
            .unpayedCA
        )
      )
    : null;

  classe = data
    ? getClasseDefWithUserAndNumbersOfOrderToRemindFromQuery(
        data?.getProfDashboard?.classe
      )
    : null;

  return (
    <EspaceProfView
      users={users}
      classe={classe}
      setTab={handleSetTab}
      tab={tab}
      csvData={csvData}
      toPage={getGoToPage(history)}
    />
  );
};

export default MaClasse;
